// extracted by mini-css-extract-plugin
export default {"noImage":"style_noImage__j7vO2","imageContainer":"style_imageContainer__5T-tk"};